import axios from "axios"

export class ServicoNotaEntrada {
  constructor() {
    this.urlServico = process.env.VUE_APP_URL_VOLUPIA + `/api/NotaEntrada`
  }
  buscarNotasEntrada() {
    return axios({
      url: this.urlServico + `/GetAll`,
      method: "GET"
    })
  }
  buscarPorId(id) {
    return axios({
      url: this.urlServico + `/GetById?id=${id}`,
      method: "GET"
    })
  }
  salvar(notaEntrada) {
    let config = {
      withCredentials: false,
      crossdomain: true
    }
    return axios.post(this.urlServico + "/Inserir", notaEntrada, config).catch(error => {
      alert("Erro ao salvar uma nova entrada " + error)
      return Promise.reject(error)
    })
  }
}
